import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const AlarmDevice = (function() {
  function GetAll(AlarmStatus, skip, take, sortOrder, searchTerms) {
    if (logComponent('AlarmDevice')) { console.debug('AlarmDevice GetAll'); }
    let params = { skip, take, sortOrder };

    AlarmStatus.forEach(status => {
      params[status] = true;
    })

    if (searchTerms) params.searchTerms = searchTerms;

    return axios.get('api/AlarmDevice/GetAll', getConfig( params));
  }
  
  function GetByFacility(id, alarmStatus, skip, take, sortOrder, searchTerms) {
    if (logComponent('AlarmDevice')) { console.debug('AlarmDevice GetByFacility'); }
    if (!id) return Promise.reject(new Error('No facility id provided'));

    let params = { skip, take, sortOrder };

    alarmStatus.forEach(status => {
      params[status] = true;
    })

    if (searchTerms) params.searchTerms = searchTerms;


    return axios.get(`api/AlarmDevice/GetByFacility/${id}`, getConfig( params));
  }

  function GetByCorporation(id, alarmStatus, skip, take, sortOrder, searchTerms) {
    if (logComponent('AlarmDevice')) { console.debug('AlarmDevice GetByCorporation'); }
    if (!id) return Promise.reject(new Error('No corporation id provided'));

    let params = { skip, take, sortOrder };

    alarmStatus.forEach(status => {
      params[status] = true;
    })

    if (searchTerms) params.searchTerms = searchTerms;


    return axios.get(`api/AlarmDevice/GetByCorporation/${id}`, getConfig( params));
  }

  function GetByUnit(id, dormant, missing, tamper, lowBattery) {
    if (logComponent('AlarmDevice')) { console.debug('AlarmDevice GetByUnit'); }
    if (!id) return Promise.reject(new Error('No unit id provided'));

    let params = {};
    if (dormant != null) params.Dormant = dormant;
    if (missing != null) params.Missing = missing;
    if (tamper != null) params.Tamper = tamper;
    if (lowBattery != null) params.LowBattery = lowBattery;

    return axios.get(`api/AlarmDevice/GetByUnit/${id}`, getConfig( params));
  }  

  function GetByMonitoredIndividual(id, Dormant, Missing, Tamper, LowBattery) {
    if (logComponent('AlarmDevice')) { console.debug('AlarmDevice GetByMonitoredIndividual'); }
    if (!id) return Promise.reject(new Error('No monitored individual id provided'));

    let params = {};
    if (Dormant != null) params.Dormant = Dormant;
    if (Missing != null) params.Missing = Missing;
    if (Tamper != null) params.Tamper = Tamper;
    if (LowBattery != null) params.LowBattery = LowBattery;

    return axios.get(`api/AlarmDevice/GetByMonitoredIndividual/${id}`, getConfig( params));
  }  
  return {
    GetAll,
    GetByFacility,
    GetByCorporation,
    GetByUnit,
    GetByMonitoredIndividual
  }
})();

export default AlarmDevice;